import { useAppSelector } from '@/app/store/store';

export function useIsApp(): boolean {
  return useAppSelector((s) => s.appEnvironment.isApp);
}